/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidbusinessdataerror3Inputs */

const en_invalidbusinessdataerror3 = /** @type {(inputs: Invalidbusinessdataerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The provided business data is invalid.`)
};

const de_invalidbusinessdataerror3 = /** @type {(inputs: Invalidbusinessdataerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die angegebenen Unternehmensdaten sind ungültig.`)
};

/**
* | output |
* | --- |
* | "The provided business data is invalid." |
*
* @param {Invalidbusinessdataerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidbusinessdataerror3 = /** @type {((inputs?: Invalidbusinessdataerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidbusinessdataerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidbusinessdataerror3(inputs)
	return de_invalidbusinessdataerror3(inputs)
});
export { invalidbusinessdataerror3 as "invalidBusinessDataError" }